<template>
  <nav
    ref="networkNavigationRef"
    class="
      absolute -inset-x-6 -bottom-5 z-10 translate-y-full rounded-bl-2xl border
      border-red-500 bg-white
      sm:-inset-x-2
      md:left-auto md:w-max
      lg:bottom-0 lg:right-8
    "
    :class="[
      open ? 'ease-out' : 'ease-in',
      {'opacity-0': !isMounted},
    ]"
  >
    <div class="px-4 py-2">
      <ul>
        <li
          v-for="(nav_group) in globals?.network_navigation.nav_group"
          :key="nav_group.id"
          class="[&:nth-child(n+2)]:mt-4"
        >
          <div class="font-semibold">
            {{ nav_group.heading }}
          </div>
          <ul>
            <li
              v-for="(nav_entry) in nav_group.nav_entries"
              :key="nav_entry.id"
            >
              <NuxtLink
                :to="getNavEntryUrl(nav_entry)"
                :target="$isExternalUrl(getNavEntryUrl(nav_entry)) ? '_blank' : '_self'"
                class="
                  flex justify-between
                  hover-focus:text-red-500
                "
              >
                <span class="mr-3">{{ nav_entry.link_title }}</span>
                <IconExternalLink
                  v-if="nav_entry.link_type.value === 'external'"
                  class="mt-0.5 h-[1.125em] shrink-0 text-red-500"
                />
                <div v-else class="shrink-0 font-bold text-red-500">
                  »
                </div>
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
const globals = inject(GlobalsKey)
const navigation = useNavigationStore()
const isMounted = ref(false)
const { getNetworkNavOpen } = storeToRefs(navigation)

const networkNavigationRef = ref<HTMLElement | undefined>(undefined)

const options = {
  duration: 325,
  initiallyClosed: true,
}

const open = useCollapse(networkNavigationRef, options)
watch(getNetworkNavOpen, (value) => {
  open.value = value
})

const getNavEntryUrl = (nav_entry: {
  url?: string
  site?: string
}) => {
  if (nav_entry.site) {
    const parsedSite = JSON.parse(nav_entry.site)

    if (parsedSite.length) {
      return parsedSite[0].url
    }
  }

  return nav_entry.url
}

const handleClickOutside = (event: MouseEvent) => {
  if (networkNavigationRef.value && !networkNavigationRef.value.contains(event.target as Node)) {
    navigation.setNetworkNavOpenState(false)
  }
}

onMounted(() => {
  isMounted.value = true // prevent visibility on load
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
